"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkSyntax = void 0;
const walkSyntax = function* (ast) {
    yield ast;
    switch (ast.type) {
        case "unary":
            yield* (0, exports.walkSyntax)(ast.operand);
            break;
        case "conjunction":
        case "disjunction":
        case "comparison":
        case "operator":
            yield* (0, exports.walkSyntax)(ast.left);
            yield* (0, exports.walkSyntax)(ast.right);
            break;
        case "ternary":
            yield* (0, exports.walkSyntax)(ast.conditional);
            yield* (0, exports.walkSyntax)(ast.truthy);
            yield* (0, exports.walkSyntax)(ast.falsy);
            break;
        case "array":
            for (const item of ast.items) {
                yield* (0, exports.walkSyntax)(item);
            }
            break;
        case "call":
            for (const arg of ast.args) {
                yield* (0, exports.walkSyntax)(arg);
            }
            break;
        case "map":
            for (const { key, value } of ast.items) {
                yield* (0, exports.walkSyntax)(key);
                yield* (0, exports.walkSyntax)(value);
            }
            break;
        default:
    }
};
exports.walkSyntax = walkSyntax;
//# sourceMappingURL=index.js.map